import React, { useContext, useState } from 'react';
import styles from './styles.module.scss';
import SignUpMobile from '../SignUpMobile';
import SignUpCode from '../SignUpCode';
import SignUpSuccess from '../SignUpSuccess';
import loginLogo from '../../../../assets/imgs/login/loginLogo.svg';
import { AdminContext } from '../../context/AdminContext';

const SignUp = ({
  setLoginModal,
  setSignUpModal,
  level1,
  setLevel1,
  level2,
  setLevel2,
  level3,
  setLevel3,
  setShowModal,
}) => {
  const { content, isElectron } = useContext(AdminContext);
  const [newuser, setNewUser] = useState({
    mobile: '',
    code: '',
    countryCode: '98',
  });
  const [loginInformation, setLoginInformation] = useState();
  const goToLoginFunction = () => {
    setLoginModal();
  };
  console.log('newuser', newuser);

  return (
    // <div
    //   className={`flex flex-row justify-start items-stretch w-full h-auto pt-4`}
    // >
    //   <div
    //     className={`flex flex-col justify-start items-start w-full h-auto  ${styles.containerPadding}`}
    //   >
    <div
      className={`loginBackground ${
        isElectron && 'loginBackgroundPadding'
      } relative`}
    >
      <div className={`flex flex-col justify-center items-center  m-auto`}>
        <img
          src={loginLogo}
          width={100}
          height={100}
          className={`makeWhite ${styles.extraMargin}`}
        />
        <p className={`${styles.extraMargin} makeWhite`}>{content?.name}</p>
        <div
          className={`flex justify-center items-stretch w-full h-auto py-6 ${styles.flexStyle} loginContent`}
        >
          <div className={`${styles.formContainer}`}>
            {level1 && (
              <SignUpMobile
                setLoginModal={setLoginModal}
                setLevel1={setLevel1}
                setLevel2={setLevel2}
                newuser={newuser}
                setNewUser={setNewUser}
              />
            )}
            {level2 && (
              <SignUpCode
                setLevel2={setLevel2}
                setLevel3={setLevel3}
                newuser={newuser}
                setSignUpModal={setSignUpModal}
                setLoginInformation={setLoginInformation}
              />
            )}
            {level3 && (
              <SignUpSuccess
                setLevel2={setLevel2}
                setLevel3={setLevel3}
                setShowModal={setShowModal}
                setSignUpModal={setSignUpModal}
                loginInformation={loginInformation}
                setLoginInformation={setLoginInformation}
              />
            )}
          </div>
        </div>
        {!level3 && (
          <div
            className={`flex flex-row justify-center items-center w-auto h-auto ${styles.bottomTexts}`}
          >
            <p>{content?.haveAccount?.title}</p>
            <p>
              <span
                className={`cursor-pointer linkStyleNoColor`}
                onClick={goToLoginFunction}
              >
                {' '}
                {content?.haveAccount?.button}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUp;
